import { render, staticRenderFns } from "./Advert5.vue?vue&type=template&id=4ef92b66&scoped=true&"
import script from "./Advert5.vue?vue&type=script&lang=ts&"
export * from "./Advert5.vue?vue&type=script&lang=ts&"
import style0 from "./Advert5.vue?vue&type=style&index=0&id=4ef92b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef92b66",
  null
  
)

component.options.__file = "Advert5.vue"
export default component.exports